const onEventsAccordionItemClicked = () => {
  const accordion = document.querySelector('#events .accordion ul');

  if (!accordion) {
    return;
  }

  const accordionItems = accordion.querySelectorAll('li');
  accordionItems.forEach(item => {
    item.addEventListener('click', () => {
      accordion.classList.add('focused');
      accordionItems.forEach(item => item.classList.remove('opened'));
      item.classList.add('opened');
    });
  });
};

document.getElementById('events') && onEventsAccordionItemClicked();
